import React, {  useState } from 'react';
import PropTypes from 'prop-types';
import { StyledModal,CalendarHeader,Border, ConfirmPlanModalBody, DateContainer} from './styles';
import { withRouter } from 'react-router-dom';
import { CommonButtonPopup } from '../../ReportsV2/styles';
import { fetchApi } from '../../../utils/methods';
import { toast } from 'react-toastify';
import { GetSpotPointsReport } from '../../../redux/constants/apiConstants';
import CommonDropdown from '../../common/CommonDropDown/CommonDropdown';
import { StyledLabel } from '../../CreateEvent/style';
import { t } from 'i18next';
import { RadioGroup, RadioLabel } from '../../EditWellnessJourney/styles';
import RadioButtonNew from '../../ContentV2/CustomRadioButtonNew';
import { AdminCloseIcon, NewCalendarBranding } from '../../../utils/icons';
import { DateCalendarWrapper } from '../../ChallengeDetailsV2/StartChallengePopUp/styles';
import dayjs from 'dayjs';
import { DateCard } from '../../ChallengeCreationAdmin/ActivityChallengeLaunch/style';
import DatePopupCalendar from '../../common/DateRangePicker/CustomCalendar';
import CSVList from '../../PeopleHomeV2/CSVList';
import { showSuccessToast } from '../../UserDashboard/ToastHelper';

const SpotPointsReportModal = ({
  show,
  icon,
  onCancel,
  modalWidth = "600px",
  modalHeight,
  companyInfo,
  onClose,
  locationDetails,
  departmentDetails,
  selectedYear
  //   history,
}) =>{

  const [loading, setLoading] = useState(false);
  const [selectedDepartment, setSelectedDepartment]  = useState(false);
  const [selectedLocation, setSelectedLocation]  = useState(false);
  const [selectedDepartmentIds, setSelectedDepartmentIds] = useState([]);
  const [selectedLocationIds, setSelectedLocationIds] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate , setEndDate] = useState(null);
  const [ datePopup ,setDatePopup] = useState("startDate")

  const[departmentDropdownOpen,setDepartmentDropdownOpen] = useState(false);
  const[locationDropdownOpen,setLocationDropdownOpen] = useState(false);
  const[selectedDuration, setSelectedDuration] = useState(1);
  const [showDatePopupModal, setShowDatePopupModal] = useState(false);
  const [printAttendees, setPrintAttendees] = useState(false);
  const [peoplePageReportData, setPeoplePageReportData] = useState([]);

  const departmentOptions = [
    { id: "all", department: "All Departments" },
    ...departmentDetails
  ];
  
  const locationOptions = [
    { id: "all", location: "All Locations" },
    ...locationDetails
  ];


  const getReportFileName = () => {
    const locationName =
      selectedLocation?.id === "all"
        ? "AllLocations"
        : selectedLocation?.location?.replace(/\s+/g, "");
  
    const departmentName =
      selectedDepartment?.id === "all"
        ? "AllDepartments"
        : selectedDepartment?.department?.replace(/\s+/g, "");
  
    const dateRangeMap = {
      1: "ThisYear",
      2: "ThisMonth",
      3: "ThisQuarter",
      4: "CustomRange"
    };
  
    const dateRange = dateRangeMap[selectedDuration];
  
    // optional: add custom date
    const customDate =
      selectedDuration === 4 && startDate && endDate
        ? `_${dayjs(startDate).format("YYYYMMDD")}-${dayjs(endDate).format("YYYYMMDD")}`
        : "";
  
    return `SpotPoints_${locationName}_${departmentName}_${dateRange}${customDate}`;
  };

 

  // useEffect(() => {
  //   if (printAttendees && peoplePageReportData.length > 0) {
  //     <CSVList
  //       Title={`Spot-Points-report`}
  //       removeCSVData={() => setPrintAttendees(false)}
  //       data={peoplePageReportData}
  //       headers={headers}
  //     />
  //   }
  // }, [printAttendees, peoplePageReportData]);


  const headers = [
    { label: "Name", key: "name" },
    { label: "Department", key: "department" },
    { label: "Location", key: "location" },
    { label: "Spot Points", key: "points_received" },
    { label: "Date", key: "awarded_at" },
    { label: "Description", key: "description" },
  ];


  const SuccessToastMessage = (title) => {
    showSuccessToast(title,"Your report is being generated", "383px");
  } 
  


  const postCompanyRewardTier = async() =>{
    const rewardPeriodId = selectedYear?.reward_period_id;
   
    if (!rewardPeriodId) return; // ✅ STOP API CALL

    setLoading(true);

    const dateRangeMap = {
      1: "this_year",
      2: "this_month",
      3: "this_quarter",
      4: "custom"
    };

    const payload = {
      company_id: companyInfo.id,
      reward_period_id: rewardPeriodId,           // Keep as is
      date_range: dateRangeMap[selectedDuration], // this_year / this_month / this_quarter
      start_date:
      selectedDuration === 4 && startDate
        ? dayjs(startDate).format("YYYY-MM-DD")
        : null,
      end_date:
      selectedDuration === 4 && endDate
        ? dayjs(endDate).format("YYYY-MM-DD")
        : null,
      department_ids: selectedDepartmentIds, // selected department ID
      location_ids: selectedLocationIds     // selected location ID
    };



    try {
      const res = await fetchApi(GetSpotPointsReport , "POST",payload);
      if (res?.status === "success") {
       
        const users = res?.data?.users || [];
        if (!users.length) {
          toast.info(res?.message);
          return; 
        }
        SuccessToastMessage("Report generated successfully!")
        // toast.success("Report generated successfully!");
        setPeoplePageReportData(users);
        setPrintAttendees(true);
        window.setTimeout(() => {
          onCancel();
        }, 2000); // give enough time
        // window.setTimeout(() => {
        //   onCancel();
        // }, 500);
      }
      else{
        toast.error(res?.data?.message);
      }
    } catch (error) {
      toast.error(error);
      
    }finally{
      setLoading(false);
    }
  }


  const onDepartmentChange = (item) => {
    setSelectedDepartment(item);
  
    if (item.id === "all") {
      const allIds = departmentDetails.map((d) => Number(d.id));
      setSelectedDepartmentIds(allIds);
    } else {
      setSelectedDepartmentIds([Number(item.id)]);
    }
  };

  const onLocationChange = (item) => {
    setSelectedLocation(item);
  
    if (item.id === "all") {
      const allIds = locationDetails.map((l) => Number(l.id));
      setSelectedLocationIds(allIds);
    } else {
      setSelectedLocationIds([Number(item.id)]);
    }
  };

  const hideShowCalendarPopup = (value) =>{
    setShowDatePopupModal(true)
    setDatePopup(value)
  }

  const hideCalendarPopup= () =>{
    setShowDatePopupModal(false)
  }
  

  const onChangeDateValue = (date, stateName) => {
    if (stateName === "startDate") {
      setStartDate(dayjs(date));
    } else if (stateName === "endDate") {
      setEndDate(dayjs(date));
    }
    setShowDatePopupModal(false);
  };


  const isDisabled =
  loading ||
  selectedDepartmentIds.length === 0 ||
  selectedLocationIds.length === 0 ||
  (selectedDuration === 4 && (!startDate || !endDate));

  const SelectPointTierLevels = () => {
    window.console.log("");
    
    return (
      <>
        <div className="formBody" style={{width:'100%'}}>
          <StyledLabel margin='20px' marginb='12px' style={{float:'unset'}}>{t("Select Date Range")}?{<span>*</span>}</StyledLabel>
          <RadioGroup>
            <RadioLabel onClick={() => setSelectedDuration(1)}>
              <RadioButtonNew
                isChecked={selectedDuration === 1}
                handler={() => setSelectedDuration(1)}
                // value={"yes"}
                background={"#85c0ea"}
              />
              <div> {t("This Year")}</div>
            </RadioLabel>
  
            <RadioLabel onClick={() => setSelectedDuration(2)}>
              <RadioButtonNew
                isChecked={selectedDuration === 2}
                handler={() => setSelectedDuration(2)}
                // value={'2'}
                background={"#85c0ea"}
              />
              <div> {t("This Month")}</div>
            </RadioLabel>
  
            <RadioLabel onClick={() => setSelectedDuration(3)}>
              <RadioButtonNew
                isChecked={selectedDuration === 3}
                handler={() => setSelectedDuration(3)}
                // value={'3'}
                background={"#85c0ea"}
              />
              <div>{t("This Quarter")}</div>
            </RadioLabel>

            {/* <RadioLabel onClick={() => setSelectedDuration(4)}>
              <RadioButtonNew
                isChecked={selectedDuration === 4}
                handler={() => setSelectedDuration(4)}
                // value={'3'}
                background={"#85c0ea"}
              />
              <div>{t("Custom Range")}</div>
            </RadioLabel> */}
          </RadioGroup>
        </div>


        {selectedDuration === 4 ? <DateContainer>
          <DateCalendarWrapper  width="278px">
            <div className="date-title">Select Start Date{<span className="symbol">*</span>}</div>
            <DateCard color={!startDate} onClick={()=>hideShowCalendarPopup("startDate")}>
              {startDate? dayjs(startDate).format('YYYY/MM/DD'): "Select date"}
              {NewCalendarBranding()}
            </DateCard>
          </DateCalendarWrapper> 
         
          <DateCalendarWrapper  width="278px">
            <div className="date-title"> Select End Date{<span className="symbol">*</span>}</div>
            <DateCard color={!endDate} onClick={()=>hideShowCalendarPopup("endDate")}>
              {endDate? dayjs(endDate).format('YYYY/MM/DD'): "Select date"}
              {NewCalendarBranding()}
            </DateCard>
          </DateCalendarWrapper>
        </DateContainer> : null}


        <CommonDropdown
          tileContainerStyle={{ width: "100%", padding:"0px 0px 0px 0px", margin: "20px 0 0 0" }}
          dropdownStyle={{ top: "95px" }}
          labelText={"Department"}
          isRequired={true}
          dropdownOpen={departmentDropdownOpen}
          placeholder={"Select Department"}
          //    title={selectedDepartment?.department}
          title={
            selectedDepartment?.id === "all"
              ? "All Departments"
              : selectedDepartment?.department
          }
          id="dropdown-recurring"
          onClick={() => setDepartmentDropdownOpen(!departmentDropdownOpen)}
          data={departmentOptions}   // ✅ FIX
          active={selectedDepartment?.department}
          onSelectParameter={["department", "id"]}  // ✅ FIX
          itemValue={true}
          valueIndex={0} // or REMOVE if not needed
          labelMargin={"0px"}
          onSelect={onDepartmentChange}
          dropIcon={true}
        />

        <CommonDropdown
          tileContainerStyle={{ width: "100%", padding:"0px 0px 20px 0px", margin: "20px 0 0 0" }}
          dropdownStyle={{ top: "95px" }}
          labelText={"Location"}
          isRequired={true}
          dropdownOpen={locationDropdownOpen}
          placeholder={"Select Location"}
          //   title={selectedLocation?.location}
          title={
            selectedLocation?.id === "all"
              ? "All Locations"
              : selectedLocation?.location
          }
          id="dropdown-recurring"
          onClick={() => setLocationDropdownOpen(!locationDropdownOpen)}
          data={locationOptions}
          active={selectedLocation?.location}
          onSelectParameter={["location", "id"]}   // ✅ FIX HERE
          itemValue={true}
          valueIndex={0}   // or REMOVE if not needed
          labelMargin={"0px"}
          onSelect={onLocationChange}
          dropIcon={true}
        />
      </>
    );
  };
      
    
  return(
    <>
      <StyledModal show={show} width={modalWidth} height={modalHeight}>
        <div className="modal-content-padding">
          <CalendarHeader style={{marginBottom:'0px'}}>
            <div className="left-content">
              {icon ? <div className="icon">{icon}</div> : null}
              <div>Export Spot Points Report</div>
            </div>
            <div className="close-icon" onClick={()=>onClose ? onClose() :onCancel()}>
              {AdminCloseIcon()}
            </div>
          </CalendarHeader>
          <StyledLabel margin={'8px'} marginb={'20px'} style={{float:'unset'}}> Download a CSV of awarded spot points activity based on your filters.  </StyledLabel>
          <Border/>
  
        </div>
  
        <ConfirmPlanModalBody>
  
          {SelectPointTierLevels()}
        </ConfirmPlanModalBody>
  
        <Border/>
    
        <div className='footer'>
          <CommonButtonPopup height="48px" width="200px" disabled={isDisabled} onClick={() => postCompanyRewardTier()}>
          Download Report
          </CommonButtonPopup>
    
        </div>
  
        {showDatePopupModal&&<DatePopupCalendar color="#DA6C74" showModal={showDatePopupModal} onClose={hideCalendarPopup} date={datePopup==="startDate"? startDate: endDate} stateDateSelected={ datePopup==="startDate"? dayjs(new Date()):startDate} changeDate={onChangeDateValue} type={datePopup} />}
      
      </StyledModal>
  
      <div>
        {printAttendees && (
          <CSVList
            Title={getReportFileName()} 
            // Title={`Spot-Points-report`}
            removeCSVData={() => setPrintAttendees(false)}
            data={peoplePageReportData}
            headers={headers}
          />
        )}
      </div>

    </>
  )};


SpotPointsReportModal.propTypes = {
  show: PropTypes.bool.isRequired,
  title:PropTypes.string, 
  onCancel: PropTypes.func.isRequired,
  modalWidth: PropTypes.string,
  modalHeight: PropTypes.string,
  icon: PropTypes.node.isRequired, 
  onClose:PropTypes.func,
  selectedYear:PropTypes.object,
  history:PropTypes.object,
  companyInfo:PropTypes.object,
  departmentDetails:PropTypes.array,
  locationDetails:PropTypes.array
};

export default withRouter((SpotPointsReportModal));
  
